(function () {
  function initSection(section) {
    const secid = section.dataset.secid;
    if (!secid || section.dataset.indexytbvidlistV3Inited === '1') return;

    const containerId = 'indexytbvidlist-v3-' + secid;
    const el = document.getElementById(containerId);
    if (!el || typeof Swiper === 'undefined') return;

    const instance = new Swiper('#' + containerId, {
      slidesPerView: 'auto',
      autoHeight: false,
      spaceBetween: 12,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next-' + secid,
        prevEl: '.swiper-button-prev-' + secid,
      },
      observer: true,
      observeParents: true,
      breakpoints: {
        769: {
          slidesPerView: 1.85,
          spaceBetween: 12,
          centeredSlides: false,
          autoHeight: false,
        },
        1351: {
          slidesPerView: 2.1,
          spaceBetween: '1%',
          centeredSlides: true,
          autoHeight: false,
        },
      },
    });

    window['indexytbvidlist_' + secid] = instance;
    section.dataset.indexytbvidlistV3Inited = '1';

    if (window.innerWidth > 1350) {
      instance.slideTo(1);
    }

    window.addEventListener('resize', () => {
      if (!window['indexytbvidlist_' + secid]) return;
      window['indexytbvidlist_' + secid].update();
    });
  }

  function boot() {
    document.querySelectorAll('[data-youtube-list-v3]').forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-youtube-list-v3]').forEach(initSection);
  });
  window.addEventListener('load', boot);
})();
